/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DocumentLimits model module.
 * @module model/DocumentLimits
 * @version 1.0.0
 */
class DocumentLimits {
    /**
     * Constructs a new <code>DocumentLimits</code>.
     * @alias module:model/DocumentLimits
     */
    constructor() { 
        
        DocumentLimits.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DocumentLimits</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DocumentLimits} obj Optional instance to populate.
     * @return {module:model/DocumentLimits} The populated <code>DocumentLimits</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DocumentLimits();

            if (data.hasOwnProperty('exists_limit')) {
                obj['exists_limit'] = ApiClient.convertToType(data['exists_limit'], 'Boolean');
            }
            if (data.hasOwnProperty('soft_limit_date')) {
                obj['soft_limit_date'] = ApiClient.convertToType(data['soft_limit_date'], 'String');
            }
            if (data.hasOwnProperty('hard_limit_date')) {
                obj['hard_limit_date'] = ApiClient.convertToType(data['hard_limit_date'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Boolean} exists_limit
 */
DocumentLimits.prototype['exists_limit'] = undefined;

/**
 * @member {String} soft_limit_date
 */
DocumentLimits.prototype['soft_limit_date'] = undefined;

/**
 * @member {String} hard_limit_date
 */
DocumentLimits.prototype['hard_limit_date'] = undefined;






export default DocumentLimits;

